import React, { FC } from 'react';
import { IonMenu } from '@ionic/react';

export interface AllieMenuProps {
  children: React.ReactNode;
  contentId: string;
  menuId: string;
  className?: string;
  type?: 'overlay' | 'reveal' | 'push';
  side?: 'start' | 'end';
  disabled?: boolean;
  onIonWillOpen?: () => void;
  onIonDidOpen?: () => void;
  onIonWillClose?: () => void;
  onIonDidClose?: () => void;
  id?: string; // Para compatibilidad con uso existente
}

/**
 * AllieMenu - Wrapper around IonMenu with consistent styling
 * Provides the side menu functionality using Ionic's robust menu system
 */
export const AllieMenu: FC<AllieMenuProps> = ({
  children,
  contentId,
  menuId,
  className,
  type = 'overlay',
  side = 'start',
  disabled = false,
  onIonWillOpen,
  onIonDidOpen,
  onIonWillClose,
  onIonDidClose,
  id,
}) => {
  return (
    <IonMenu
      contentId={contentId}
      menuId={menuId}
      id={id || menuId}
      className={className}
      type={type}
      side={side}
      disabled={disabled}
      onIonWillOpen={onIonWillOpen}
      onIonDidOpen={onIonDidOpen}
      onIonWillClose={onIonWillClose}
      onIonDidClose={onIonDidClose}
    >
      {children}
    </IonMenu>
  );
};

AllieMenu.displayName = 'AllieMenu';
